import { render, staticRenderFns } from "./SanityWidget.vue?vue&type=template&id=58881681"
import script from "./SanityWidget.vue?vue&type=script&lang=js"
export * from "./SanityWidget.vue?vue&type=script&lang=js"
import style0 from "./SanityWidget.vue?vue&type=style&index=0&id=58881681&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports